import background1 from "../assets/bg1.jpg"; // 深色背景
import background2 from "../assets/bg2.jpg"; // 黄色背景
import background3 from "../assets/bg3.jpg"; // 订阅部分背景
import axios from 'axios';
import React,{useState } from 'react';

const Home = () => {

    const [data, setData] = useState(null);
    const [error, setError] = useState(null);  // 错误状态

    const fetchPaymentInfo = async () => {
        try {

          const response = await axios.get('https://periken.com/api.php', {
              params: {
                act: 'query',
                pid: '1000',
                key: 'o0OHLV9LT092mclKtfk05L9M2OlJVOz5'
              }
            });

          setData(response.data);  // 请求成功，设置数据
          console.log('Fetched Data:', response.data);  // 打印数据到控制台
        } catch (err) {
          setError('Error fetching data');
          console.error(err);
        }
      };


    return (
        <div className="w-full">
            {/* 第一区块 */}

            <section className="w-full relative">
                <div
                    className="w-full flex items-center justify-center"
                    style={{
                        backgroundImage: `url(${background1})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        aspectRatio: "16 / 9", // 保持16:9比例
                        display: "flex" // 确保 div 是 flex 容器
                    }}
                >
                    <div className="flex flex-col items-center justify-center text-white text-center px-6"
                        style={{
                            height: "100%" // 让内部 div 充满整个背景
                        }}
                    >
                        <h1 className="text-5xl font-extrabold text-yellow-400"
                        style={{ textShadow: "2px 2px 2px black" }}>美味煎饼</h1>
                            <p className="text-lg text-gray-100 mt-4]"
                            style={{ textShadow: "1px 1px 1px black" }}
                            >
                                品尝山东最美味的煎饼！精选优质食材，现做现售。
                            </p>
                        <button className="mt-6 px-6 py-3 bg-yellow-500 text-gray-900 text-lg font-bold rounded-full shadow-lg hover:bg-yellow-600"
                        onClick={fetchPaymentInfo} >
                            点击下单
                        </button>
                    </div>
                </div>
            </section>



            {/* 第二区块 */}
            <section className="w-full relative">
                <div
                    className="w-full"
                    style={{
                        backgroundImage: `url(${background2})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        aspectRatio: "16 / 9"
                    }}
                >
                    <div className="flex flex-col items-center justify-center text-gray-900 text-center px-6 py-20"
                       style={{
                            height: "100%" // 让内部 div 充满整个背景
                        }}
                    >
                        <h2 className="text-4xl font-bold">传统配方 手动现做</h2>
                        <p className="mt-4 text-lg text-gray-100">香脆、新鲜、美味。</p>
                    </div>
                </div>
            </section>

            {/* 第三区块 */}
            <section className="w-full relative">
                <div
                    className="w-full"
                    style={{
                        backgroundImage: `url(${background3})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        aspectRatio: "16 / 9"
                    }}
                >
                    <div className="flex flex-col items-center justify-center text-gray-900 text-center px-6 py-20"
                      style={{
                            height: "100%" // 让内部 div 充满整个背景
                        }}
                    >
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                            <h3 className="text-2xl font-bold">Subscribe for Updates</h3>
                            <p className="mt-2">Get exclusive offers and discounts directly to your inbox.</p>
                            <div className="mt-4 flex">
                                <input type="email" placeholder="Your Email" className="p-3 rounded-l-lg w-full border" />
                                <button className="bg-yellow-500 text-gray-900 px-4 py-3 rounded-r-lg font-bold">Subscribe</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 第四区块：尾部导航 */}
            <footer
                className="w-full bg-black text-white flex flex-col items-center justify-center text-center"
                style={{ aspectRatio: "16 / 1" }} // 16:2 的比例
            >
                <p className="text-lg">© 2025 Your Brand. All rights reserved.</p>
                <div className="flex justify-center gap-6 mt-4">
                    <a href="#" className="hover:text-yellow-400">About</a>
                    <a href="#" className="hover:text-yellow-400">Services</a>
                    <a href="#" className="hover:text-yellow-400">Contact</a>
                </div>
            </footer>


        </div>
    );
};

export default Home;
